export const cultureTopics = [
  {
    id: "culture-1",
    group: "发展历史",
    title: "从赛璐璐到数字作画：动画技术的迁徙",
    summary:
      "从一张张赛璐璐片到全数字流程，动画的制作方式在过去数十年间经历了彻底的重写。本专题梳理这段技术史的关键节点。",
    reason:
      "推荐理由：想理解今天动画为何长这样，就必须知道它是怎么一步步走过来的。",
    cover:
      "https://readdy.ai/api/search-image?query=anime%20themed%20illustration%20of%20classic%20cel%20animation%20frames%20transitioning%20into%20digital%20art%20tablets%2C%20deep%20blue%20workshop%20with%20warm%20amber%20light%2C%20editorial%20composition&width=1200&height=700&seq=cul-01&orientation=landscape",
    articles: ["analysis-8", "news-11", "work-9"],
  },
  {
    id: "culture-2",
    group: "发展历史",
    title: "深夜档的崛起：动画与观众的新约定",
    summary:
      "深夜档曾是小众作品的容身之处，却逐渐成为大量经典诞生的土壤。本专题讲述这段档期文化如何形成。",
    reason:
      "推荐理由：许多你熟悉的作品，正是从深夜档走向大众视野的。",
    cover:
      "https://readdy.ai/api/search-image?query=anime%20city%20at%20midnight%20with%20glowing%20billboards%20and%20a%20figure%20watching%20a%20screen%2C%20deep%20blue%20night%20palette%20with%20amber%20accents%2C%20cinematic%20illustration&width=1200&height=700&seq=cul-02&orientation=landscape",
    articles: ["news-6", "analysis-3", "work-6"],
  },
  {
    id: "culture-3",
    group: "名家介绍",
    title: "那些塑造时代的创作者",
    summary:
      "每一代动画人都有自己的执念与风格。本专题走近数位在不同岗位上留下深刻印记的创作者，理解作品背后的手艺。",
    reason:
      "推荐理由：创作者的故事，往往比作品本身更动人。",
    cover:
      "https://readdy.ai/api/search-image?query=anime%20illustration%20of%20a%20storyboard%20artist%20desk%20with%20sketches%20and%20warm%20desk%20lamp%2C%20deep%20blue%20studio%20ambience%2C%20editorial%20magazine%20style&width=1200&height=700&seq=cul-03&orientation=landscape",
    articles: ["analysis-6", "work-1", "work-3"],
  },
  {
    id: "culture-4",
    group: "名家介绍",
    title: "声音的匠人：声优文化入门",
    summary:
      "一个角色的灵魂，很大程度上由声音赋予。本专题介绍声优这一职业的日常与背后的文化生态。",
    reason:
      "推荐理由：了解了声优的付出，再看动画会多一层感受。",
    cover:
      "https://readdy.ai/api/search-image?query=anime%20illustration%20of%20a%20recording%20studio%20with%20microphone%20and%20soundproof%20walls%2C%20warm%20amber%20and%20deep%20blue%20lighting%2C%20professional%20editorial%20style&width=1200&height=700&seq=cul-04&orientation=landscape",
    articles: ["news-5", "work-7", "work-12"],
  },
  {
    id: "culture-5",
    group: "周边文化",
    title: "手办与模型：把喜欢留在身边",
    summary:
      "从树脂到PVC，从量产到限量，周边模型早已不只是收藏品，而是一种表达喜欢的方式。本专题带你了解这门文化。",
    reason:
      "推荐理由：搞懂周边，才能真正进入动漫文化的圈层。",
    cover:
      "https://readdy.ai/api/search-image?query=anime%20style%20illustration%20of%20collectible%20figures%20and%20models%20arranged%20on%20a%20shelf%2C%20soft%20studio%20lighting%20with%20deep%20blue%20background%2C%20clean%20modern%20composition&width=1200&height=700&seq=cul-05&orientation=landscape",
    articles: ["work-4", "news-4", "work-2"],
  },
  {
    id: "culture-6",
    group: "周边文化",
    title: "同人志与创作社群：热爱的另一种形态",
    summary:
      "在官方作品之外，爱好者们用同人创作延续着故事。本专题讲述同人文化的起源、规则与它独特的分寸感。",
    reason:
      "推荐理由：同人文化是动漫生态中最有生命力的一环，值得了解。",
    cover:
      "https://readdy.ai/api/search-image?query=anime%20illustration%20of%20colorful%20doujinshi%20booklets%20fan%20art%20displayed%20at%20a%20creator%20convention%20table%2C%20warm%20amber%20and%20deep%20blue%20lighting&width=1200&height=700&seq=cul-06&orientation=landscape",
    articles: ["analysis-9", "news-8", "news-10"],
  },
];